export function initHelpCenterRedirectModalLink() {
  const links = this.window.document.querySelectorAll(
    ".help-center-redirect-modal-link"
  );

  links.forEach((link: HTMLAnchorElement) => {
    link.href = "javascript:void(0)";
    link.role = "button";
    link.addEventListener("click", () => {
      this.window.store.dispatch({
        type: "modals/openModal",
        payload: { type: "help_center_redirect" }
      });
    });
  });
}
